import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { DialogService } from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

import { CurrentStockDialogComponent } from '../current-stock-dialog/current-stock-dialog.component';

@Component({
  standalone: true,
  selector: 'app-stock-button',
  templateUrl: './stock-button.component.html',
  styleUrls: ['./stock-button.component.scss'],
  imports: [MatButton, MatTooltip, TranslatePipe, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockButtonComponent {
  private readonly dialog = inject(DialogService);
  private readonly locale = inject(LocaleService);

  protected openCurrentStock(): void {
    this.dialog
      .fullscreenDialog(
        CurrentStockDialogComponent,
        {
          title: this.locale.translate('shared.stockEntry.dialogTitle'),
          subTitle: this.locale.translate('shared.stockEntry.dialogSubtitle'),
          cancelButton: true,
          cancelButtonText: this.locale.translate('cancel'),
          confirmButton: true,
          confirmButtonText: this.locale.translate('shared.stockEntry.saveStock'),
        },
        {
          width: 'min(800px, 95vw)',
          maxWidth: '95vw',
        },
      )
      .subscribe();
  }
}
